import { Routes } from '@angular/router';
import { OrderSuccessComponent } from './views/common/components/order-success/order-success.component';

export const Approutes: Routes = [
  {
    path: '',
    redirectTo: '/authentication/sign-up', // Default to sign-up page
    pathMatch: 'full',
  },
  {
    path: 'authentication',
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'order-success',
    component: OrderSuccessComponent,
  },
  {
    path: '**',
    redirectTo: '/authentication/sign-up',
  },
];
